/**
 * Normalizes a query param value to an array of numbers.
 * Accepts single numbers, arrays of numbers, comma-separated strings,
 * or null/undefined and returns a sanitized number[] without NaN values.
 */
export function toNumberArrayFromQuery(value: string | number | number[] | null | undefined): number[] {
    if (value == null) return [];
    if (Array.isArray(value)) {
        return value
            .map((v) => typeof v === 'string' ? Number(v) : v)
            .filter((n) => typeof n === 'number' && !isNaN(n));
    }
    if (typeof value === 'number') {
        return isNaN(value) ? [] : [value];
    }
    // string
    return value
        .split(',')
        .map((s) => Number(s))
        .filter((n) => !isNaN(n));
}


